const VetApprovedSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
      <circle
        cx="64"
        cy="64"
        r="30"
        fill="none"
        stroke="#063"
        strokeWidth="2"
      />
      <path
        d="M48 64l10 10 22-22"
        fill="none"
        stroke="#063"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VetApprovedSVG;
